import { invalidFirstNameErrorMap } from './errorDictionary';
import { isValidName } from '../../utils/fieldValidators';
import useValidators from './useValidators';
function useValidFirstName() {
    const errorMessageMap = [invalidFirstNameErrorMap];
    const validators = [isValidName];
    return useValidators(errorMessageMap, validators);
}
export default useValidFirstName;
